<template>
  <el-dialog
    title="国际退款详情"
    :visible.sync="visible"
    width="900px"
    append-to-body
    @closed="onClosed"
  >
    <div v-loading="loading">
      <el-descriptions v-if="apply" :column="2" border size="small" title="主单信息">
        <el-descriptions-item label="退款申请单号">{{ apply.refundNum }}</el-descriptions-item>
        <el-descriptions-item label="收款编号">{{ apply.telegraphicTransferNum }}</el-descriptions-item>
        <el-descriptions-item label="业务实体">{{ apply.businessEntity }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ apply.state }}</el-descriptions-item>
        <el-descriptions-item label="当前节点">{{ displayCurrentNode }}</el-descriptions-item>
        <el-descriptions-item label="退款金额">{{ apply.returnAmount }} {{ apply.currency }}</el-descriptions-item>
        <el-descriptions-item label="折算USD">{{ apply.returnAmountUsd }}</el-descriptions-item>
        <el-descriptions-item label="收款单位">{{ apply.payee }}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{ apply.bankAccount }}</el-descriptions-item>
        <el-descriptions-item label="开户行">{{ apply.openBank }}</el-descriptions-item>
        <el-descriptions-item label="联行号">{{ apply.customerBankNo }}</el-descriptions-item>
        <el-descriptions-item label="SWIFT">{{ apply.swiftCode }}</el-descriptions-item>
        <el-descriptions-item label="申请人">{{ apply.applicationName }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" :span="2">{{ apply.applicationTime }}</el-descriptions-item>
        <el-descriptions-item label="退款理由" :span="2">
          <div class="reason-content">{{ apply.reason }}</div>
        </el-descriptions-item>
      </el-descriptions>

      <div style="margin-top: 16px;font-weight: 600;">审批节点</div>
      <el-table :data="displayNodes" border size="mini" style="width: 100%;margin-top: 8px;">
        <el-table-column prop="nodeSeq" label="序号" width="60" />
        <el-table-column prop="nodeName" label="节点" />
        <el-table-column prop="approverName" label="审批人" />
        <el-table-column prop="status" label="状态" width="90">
          <template v-slot="{row}">
            <span :class="nodeStatusClass(row.status)">{{ row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="skipFlag" label="跳过" width="70">
          <template v-slot="{row}">{{ row.skipFlag === 1 ? '是' : '否' }}</template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 16px;font-weight: 600;">审批流水</div>
      <el-table :data="records" border size="mini" height="200" style="width: 100%;margin-top: 8px;">
        <el-table-column prop="approvalTime" label="时间" min-width="140" />
        <el-table-column prop="nodeName" label="节点">
          <template v-slot="{ row }">
            {{ displayRecordNodeName(row) }}
          </template>
        </el-table-column>
        <el-table-column prop="approver" label="操作人" />
        <el-table-column prop="approvalResult" label="结果" width="80" />
        <el-table-column prop="approvalOpinion" label="意见" min-width="120" />
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click="visible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { overseasRefundDetail, overseasRefundDetailBySnapshot } from '@/API';

export default {
  name: 'OverseasRefundDetailDialog',
  data () {
    return {
      visible: false,
      loading: false,
      apply: null,
      nodes: [],
      records: []
    };
  },
  computed: {
    /** 仅展示真实审批节点；海外资金等 ccOnly 抄送不展示（财务通过后顺带发信） */
    displayNodes () {
      return (this.nodes || []).filter(n => n && n.ccOnly !== 1 && n.ccOnly !== true);
    },
    /** 驳回/召回后节点已清空，展示固定文案避免空白 */
    displayCurrentNode () {
      if (!this.apply) {
        return '';
      }
      if (this.apply.currentNodeName) {
        return this.apply.currentNodeName;
      }
      if (this.apply.state === '驳回待提交') {
        return '待申请人重提';
      }
      return '-';
    }
  },
  methods: {
    nodeStatusClass (status) {
      if (status === '已通过') return 'node-status--passed';
      if (status === '已驳回') return 'node-status--rejected';
      if (status === '已跳过') return 'node-status--skipped';
      if (status === '待办') return 'node-status--todo';
      return '';
    },
    /** 召回非审批模板节点；历史数据 nodeName 为空时兜底「申请人」 */
    displayRecordNodeName (row) {
      if (!row) {
        return '';
      }
      if (row.nodeName) {
        return row.nodeName;
      }
      if (row.approvalResult === '召回') {
        return '申请人';
      }
      return '-';
    },
    open (overseasRefundId) {
      if (!overseasRefundId) {
        return;
      }
      this.visible = true;
      this.loading = true;
      overseasRefundDetail({ overseasRefundId })
        .then(res => {
          this.fillDetail(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 已办：反读轮次快照 */
    openSnapshot (snapshotId) {
      if (!snapshotId) {
        return;
      }
      this.visible = true;
      this.loading = true;
      overseasRefundDetailBySnapshot({ snapshotId })
        .then(res => {
          this.fillDetail(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fillDetail (res) {
      const data = (res && res.data && res.data.data) || {};
      this.apply = data.apply || null;
      this.nodes = data.nodes || [];
      this.records = data.records || [];
    },
    onClosed () {
      this.apply = null;
      this.nodes = [];
      this.records = [];
    }
  }
};
</script>

<style scoped>
.node-status--passed {
  color: #67c23a;
}
.node-status--rejected {
  color: #f56c6c;
}
.node-status--skipped {
  color: #909399;
}
.node-status--todo {
  color: #e6a23c;
}
.reason-content {
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 22px;
  max-height: 160px;
  overflow-y: auto;
}
</style>
